import React from 'react';
import { Heart } from 'lucide-react';

export function FavouritesIndicator({ t, showFavourites, setShowFavourites, displayedOppsLength }) {
  if (!showFavourites) return null;

  return (
    <div className="flex items-center justify-between bg-rose-500/10 border border-rose-500/30 rounded-xl px-5 py-3 mb-4">
      <div className="flex items-center gap-2 text-rose-400 text-sm font-medium">
        <Heart className="w-4 h-4 fill-current" />
        {t('viewingFavourites', { count: displayedOppsLength, plural: displayedOppsLength !== 1 ? 's' : '' })}
      </div>
      <button
        onClick={() => setShowFavourites(false)}
        className="text-xs text-slate-400 hover:text-white transition-colors"
      >
        {t('backToAll')}
      </button>
    </div>
  );
}

export default FavouritesIndicator;
